import { Button, FormControl, Grid, TextField, Typography } from '@mui/material'
import { CustomAutocomplete } from 'common'
import React from 'react'
import SectionQuote from './SectionQuote'
import { ArrowRightCircle } from 'react-feather'

export const FormStepApplication = ({ useFetchInit }) => {

  const {
    //------------- Generales
    //------------- globalStates
    globalStates,
    //------------- Helpers
    Helpers,
    //------------- Formularios
    Forms,
    //------------- FetchData
    FetchData,
    //------------- Actions
    Actions,
    defaultData
  } = useFetchInit

  const { optionsOrigenFinanciero } = defaultData

  // ------------------------------------------------ Acciones

  const { onSubmitFormApplies } = Actions
  // ------------------------------------------------ globalStates
  const { stepApplilication, formOpeningMode } = globalStates

  // ------------------------------------------------ Formularios
  const { FormRequestGlobal } = Forms
  const { formState, onInputChange, onSelectSearchChange, onInputChangeForNumber } = FormRequestGlobal

  // ------------------------------------------------ FetchData
  const { fetchAllCustomers, fetchAllVehicles, fetchAllQuotes, fetchAllOrigins } = FetchData
  // const { vehicles } = fetchAllVehicles
  const { customers } = fetchAllCustomers
  const { quotes } = fetchAllQuotes
  const { dataOrigins, loadingFetchOrigins } = fetchAllOrigins

  return (
    <form onSubmit={onSubmitFormApplies}>
      <Typography sx={{ mt: 3, fontWeight: 'bold' }} variant='subtitle2'>
        Datos Generales
      </Typography>
      <div className="border-bottom border-dark"></div>
      <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }} sx={{ mb: 2, mt: 2 }}>
        <Grid item xs={12} sm={12} md={6} lg={6}>
          <FormControl fullWidth>
            <label htmlFor="credito_fecha">* Fecha de Registro</label>
            <TextField
              id='credito_fecha'
              name='credito_fecha'
              value={formState.credito_fecha}
              onChange={onInputChange}
              size='small'
              placeholder='Día de registro'
              type='date'
              variant={'filled'}
              InputProps={{
                readOnly: true
              }}
              required
            />
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={6}>
          <FormControl fullWidth>
            <label htmlFor="credito_dia_pago">* Fecha de Pago</label>
            <TextField
              id='credito_dia_pago'
              name='credito_dia_pago'
              value={formState.credito_dia_pago}
              onChange={onInputChange}
              size='small'
              placeholder='Día de pago'
              type='date'
              variant={'filled'}
              InputProps={{ readOnly: true }}
              required
            />
          </FormControl>
        </Grid>
      </Grid>
      <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }} sx={{ mb: 2 }}>
        <Grid item xs={12} sm={12} md={6} lg={6}>
          <FormControl fullWidth>
            <label htmlFor="idcliente">* Cliente</label>
            <CustomAutocomplete
              customId="idcliente"
              customName="idcliente"
              customValue={formState.idcliente}
              customOnChange={(target, value) => onSelectSearchChange({ target: { name: 'idcliente', value: value.value } })}
              customPlaceholder='Seleccionar cliente'
              customOptions={
                customers.map(({ idcliente, dpi, nombre, apellido, departamento, municipio }) => ({
                  value: idcliente,
                  name: `${dpi} - ${nombre} ${apellido} - ${departamento}, ${municipio}`
                }))
              }
              customDisabled={true}
              customDisableClearable={true}
            />
          </FormControl>
        </Grid>

        <Grid item xs={12} sm={12} md={6} lg={6}>
          <FormControl fullWidth>
            <label htmlFor="idorigen">* Origen financiero</label>
            <CustomAutocomplete
              customId="idorigen"
              customName="idorigen"
              customValue={formState.idorigen}
              customOnChange={(target, value) =>
                onSelectSearchChange({ target: { name: 'idorigen', value: value.value } })
              }
              customPlaceholder="Seleccionar origen"
              customOptions={
                dataOrigins.map(({ idorigen, nombre }) => ({
                  value: idorigen,
                  name: nombre
                }))
              }
              customDisabled={true}
              customDisableClearable={true}
            />
          </FormControl>
        </Grid>
      </Grid>
      <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }} sx={{ mb: 2 }}>
        <Grid item xs={12} sm={12} md={6} lg={6}>
          <FormControl fullWidth>
            <label htmlFor="idcotizacion">* Cotizacion</label>
            <CustomAutocomplete
              customId="idcotizacion"
              customName="idcotizacion"
              customValue={formState.idcotizacion}
              customOnChange={(target, value) => onSelectSearchChange({ target: { name: 'idcotizacion', value: value.value } })}
              customPlaceholder='Seleccionar una cotizacion'
              customOptions={
                quotes.map(({ idcotizacion, numero_cotizacion, nombre_cliente, tipo_cuota }) => ({
                  value: idcotizacion,
                  name: `${numero_cotizacion} - ${tipo_cuota} - ${nombre_cliente}`
                }))
              }
              customDisabled={true}
              customDisableClearable={true}
            />
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={6}>
          <FormControl fullWidth>
            <label htmlFor="costo_papeleria">* Costo Papelería (Q)</label>
            <TextField
              id='costo_papeleria'
              name='costo_papeleria'
              value={formState.costo_papeleria}
              onChange={onInputChangeForNumber}
              size='small'
              placeholder='Costo de papelería'
              type='text'
              variant={'filled'}
              InputProps={{ readOnly: true }}
              required
            />
          </FormControl>
        </Grid>
      </Grid>

      {(formState.idcotizacion > 0) && (
        <SectionQuote
          FormRequestGlobal={FormRequestGlobal}
        />
      )}

      <Grid container justifyContent="center" alignItems="center" style={{ height: '100%' }}>
        <Grid item xs={12}>
          <div className="text-center">
            <Button
              endIcon={<ArrowRightCircle />}
              variant="contained"
              type="submit"
              className='btn-round'
              color='primary'
              sx={{ mr: 2, ml: 2, mt: 3 }}
            >
              Continuar
            </Button>
          </div>
        </Grid>
      </Grid>

    </form>

  )
}

